// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1EQro","cell":"ColumnAccessor_cell__2A5em","firstCellAccent":"ColumnAccessor_firstCellAccent__1_I4R"};